import {
  Select,
  Stack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/store.hook";
import { Target } from "types/Target";

type TargetsFilterProps = {
  placeholderTarget: string;
  targets : any[];
  handlerOnChangeTarget: (params: any) => any;
};

/**
 * A React component that renders a filter for selecting targets.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.placeholderTarget - The placeholder text for the select input.
 * @param {function} props.handlerOnChangeTarget - The handler function to call when the selected target changes.
 * @param {Array} props.targets - The array of target objects to display in the select options.
 *
 * @typedef {Object} Target - The target object.
 * @property {number} id - The unique identifier of the target.
 * @property {number} index - The index of the target.
 * @property {string} title - The title of the target.
 *
 * @typedef {Object} TargetsFilterProps - The props for the TargetFilter component.
 * @property {string} placeholderTarget - The placeholder text for the select input.
 * @property {function} handlerOnChangeTarget - The handler function to call when the selected target changes.
 * @property {Array<Target>} targets - The array of target objects to display in the select options.
 *
 * @returns {JSX.Element} The rendered TargetFilter component.
 */
export default function TargetFilter({
  placeholderTarget,
  handlerOnChangeTarget,
  targets
}: TargetsFilterProps) {



  return (
    <Stack spacing={3}>
      <Select
        placeholder={placeholderTarget}
        onChange={handlerOnChangeTarget}
      >
        {targets?.map((target: Target, index: number) => {
          return (
            <option key={index} value={target?.id}>
              Obiettivo {target?.index} - {target?.title}
            </option>
          );
        })}
      </Select>
    </Stack>
  );
}
